/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, invited: NonNullable<unknown> }} Invite_X15_Other_AccountInputs */

const en_invite_x15_other_account = /** @type {(inputs: Invite_X15_Other_AccountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You are signed in as ${i?.current}, but this invitation was sent to ${i?.invited}.`)
};

/**
* | output |
* | --- |
* | "You are signed in as {current}, but this invitation was sent to {invited}." |
*
* @param {Invite_X15_Other_AccountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const invite_x15_other_account = /** @type {((inputs: Invite_X15_Other_AccountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_Other_AccountInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_invite_x15_other_account(inputs)
});